import React from 'react';
import DealersMap from './pages/DealersMap';


const App = ({ locale }) => {
    return (
        <DealersMap locale={locale} />
    );
}

export default App;
